<template>
    <website-page>
        <div id="contact" class="main-section pt-4">
            <div class="px-3 pb-5 container mx-auto" style="max-width: 730px;">
                <contact-form display-header></contact-form>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#about-us'" variant="outline-light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </div>
        </div>
    </website-page>
</template>

<script>
    import ContactForm from "@/components/contact-form.vue";
    import {translate} from "../../vue-components/helpers/i18n";

    export default {
        name: `contact`,
        components: {ContactForm},
        metaInfo: {
            title: translate(`Contact Us|Contactez-nous`),
            meta: [
                { name: `description`, content: translate(`More information about our SaaS Portal for Guest WiFi or Digital Signage`) }
            ]
        }
    }
</script>

<style lang="scss" scoped>
</style>
